import { adminTenants } from '@application/config';

/**
 * Tenant da sessão, lido do `authorization` gravado no localStorage.
 *
 * Existe aqui, e não em cada consumidor, porque o parse já era feito em dois
 * lugares e uma terceira cópia divergiria na primeira mudança de chave. Devolve
 * `null` quando não há sessão ou quando o storage está bloqueado — o navegador
 * lança "Access is denied" nesse caso, e uma tela quebrada é pior que um estado
 * vazio.
 */
export const currentTenantId = (): string | null => {
  try {
    const authorization = localStorage.getItem('actuar/authorization');
    if (!authorization) return null;

    return JSON.parse(authorization)?.TenantId ?? null;
  } catch {
    return null;
  }
};

export const isAdminScope = (): boolean => {
  const tenantId = currentTenantId();

  if (!tenantId) {
    return false;
  }

  try {
    const isAdmin = tenantId === adminTenants?.[1].account;
    const isPaguelaAdmin = tenantId === adminTenants?.[5].account;
    const isFacilFitAdmin = tenantId === adminTenants?.[8].account;
    const isToletusAdmin = tenantId === adminTenants?.[9].account;
    const isEdizAdmin = tenantId === adminTenants?.[11].account;
    const isTickouAdmin = tenantId === adminTenants?.[12].account;

    return isAdmin || isPaguelaAdmin || isFacilFitAdmin || isToletusAdmin || isEdizAdmin || isTickouAdmin;
  } catch (e) {
    return false;
  }
};
